// @core/api/endpoints/platform/get_platform_usage.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformUsageResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get platform usage statistics
 * Returns current resource usage statistics for the platform including active users, storage consumption, and API call counts for the specified period.
 */
export async function GetPlatformUsage(
  platform_id: string,
  options?: RequestOptions
): Promise<PlatformUsageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/usage`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.get<PlatformUsageResponse>(requestPath, { ...requestOptions });
}
